import { State as UserVehiclesState } from "@client/reducers/user-vehicles-reducer";
import { Selector } from "@ngrx/store";
import { Vehicule } from "@client/utils/shared-constants";
export const getHasSuccess: Selector<UserVehiclesState, boolean> = (state: UserVehiclesState) => state.hasSuccess;
export const getHasError: Selector<UserVehiclesState, boolean> = (state: UserVehiclesState) => state.hasError;
export const getIsLoading: Selector<UserVehiclesState, boolean> = (state: UserVehiclesState) => state.isLoading;
export const getMessage: Selector<UserVehiclesState, string | null> = (state: UserVehiclesState) => state.message;
export const getCollection: Selector<UserVehiclesState, Vehicule[]> = (state: UserVehiclesState) => state.collection;
